import PropTypes from 'prop-types';
import { IconColors, IconKeys, iconRenderer } from '@components/icon';
import { PreferenceDownloadTypes } from '@constants';
import React, { useCallback, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@components/popover';
import { Button, ButtonTypes } from '@leegality/leegality-react-component-library';
import { useFetchDownloadURLQuery } from '@pages/api/fetch-download-url';
import { cn } from '@utils/general';
import { getTranslation } from '@utils';

const DownloadPopover = ({
  id, noticeUrl, recordUrl, isSdk,
}) => {
  const [popoverId, setPopoverId] = useState('');

  const { isPending, mutateAsync } = useFetchDownloadURLQuery();
  const handleClick = async (filename) => {
    await mutateAsync({
      downloadUrl: filename === 'notice' ? noticeUrl : recordUrl,
      fileName: filename,
    });
    setPopoverId('');
  };

  const getDownloadIcon = useCallback(
    () => iconRenderer({ iconName: IconKeys.Download, color: IconColors.GRAY }),
    [],
  );

  return (
    <Popover open={popoverId === id} onOpenChange={setPopoverId}>
      <PopoverTrigger onClick={() => setPopoverId(id)}>
        <Button
          type={ButtonTypes.SECONDARY}
          renderIcon={getDownloadIcon}
          loading={isPending}
          borderLess={isSdk}
          className={cn({ 'absolute top-1 right-11 !bg-transparent': isSdk })}
          label={!isSdk && getTranslation('DOWNLOAD_LABEL')}
        />
      </PopoverTrigger>
      <PopoverContent className="download-popover-content z-[var(--z-sdk-popover)] relative bg-white border rounded">
        <div
          className={cn('text-sm text-gray-600 bg-white border rounded shadow-md right-14 top-4 min-w-52', { absolute: isSdk })}
        >
          {PreferenceDownloadTypes.map((type) => {
            const isDisabled = type.id === 'notice' && !noticeUrl;
            return (
              <div
                key={type.id}
                className={`px-4 py-2 cursor-pointer hover:bg-gray-50 hover:rounded ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => !isDisabled && handleClick(type.id)}
                onKeyDown={(e) => e.key === 'Enter' && !isDisabled && handleClick(type.id)}
                tabIndex={isDisabled ? -1 : 0}
                role="button"
                aria-label="Select"
                aria-disabled={isDisabled}
              >
                {getTranslation(type.labelKey)}
              </div>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};

DownloadPopover.defaultProps = {
  noticeUrl: '',
  recordUrl: '',
  isSdk: false,
};

DownloadPopover.propTypes = {
  id: PropTypes.string.isRequired,
  noticeUrl: PropTypes.string,
  recordUrl: PropTypes.string,
  isSdk: PropTypes.bool,
};

export default DownloadPopover;
